import { Box, useToast } from '@chakra-ui/react';
import * as Sentry from '@sentry/react';
import React, { useMemo } from 'react';
import { RouteComponentProps } from 'react-router';
import { useHistory } from 'react-router-dom';

import {
  dashboardRoutePadding,
  errorToastConfig,
  errorToastId,
} from 'packages/common-frontend/constants';
import { VerificationReceivableEligibilityContainer } from 'packages/verifications/ui/VerificationReceivableEligibilityContainer';
import { isVerificationPipelineRunId } from 'packages/verifications/ui/VerificationTableSharedComponents';

interface VerificationEligiblityRouteMatchParams {
  artifactDocumentId?: string;
  creditFacilityId?: string;
  reportingDate?: string;
  fileVersion?: string;
  verificationReportId?: string;
}

interface VerificationEligibilityRouteProps
  extends RouteComponentProps<VerificationEligiblityRouteMatchParams> {}

export const VerificationEligibilityRoute = (
  routeParams: VerificationEligibilityRouteProps,
) => {
  const toast = useToast();
  const history = useHistory();

  let routeLevelError = false;

  const {
    artifactDocumentId,
    creditFacilityId,
    reportingDate,
    fileVersion: fileVersionString = '',
    verificationReportId,
  } = routeParams.match.params;
  const fileVersion = Number.parseInt(fileVersionString, 10);

  const pipelineRunId = useMemo(() => {
    const pipelineRunParams = {
      artifactDocumentId,
      creditFacilityId,
      reportingDate,
      fileVersion,
    };
    return isVerificationPipelineRunId(pipelineRunParams)
      ? pipelineRunParams
      : undefined;
  }, [artifactDocumentId, creditFacilityId, reportingDate, fileVersion]);

  return (
    <Box width="100%" padding={dashboardRoutePadding}>
      <Sentry.ErrorBoundary
        onError={() => {
          if (!routeLevelError && !toast.isActive(errorToastId)) {
            errorToastConfig.title = `Failed to load new verification route`;
            routeLevelError = true;
            toast(errorToastConfig);
            history.push('/');
          }
        }}
      >
        {pipelineRunId && verificationReportId && (
          <VerificationReceivableEligibilityContainer
            verificationReportId={verificationReportId}
            pipelineRunId={pipelineRunId}
          />
        )}
      </Sentry.ErrorBoundary>
    </Box>
  );
};
